import { Component, AfterViewInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { DataService } from "src/app/services/data.service";
import { DialogService } from "src/app/services/dialog.service";
import { GetInformacionService } from "src/app/services/perfilamiento/get-informacion.service";

@Component({
  selector: "app-validar-correo",
  templateUrl: "./validar-correo.component.html",
  styleUrls: ["./validar-correo.component.scss"],
})
export class ValidarCorreoComponent implements AfterViewInit {
  seccion = "datos";
  formularioInformacion: FormGroup;
  correos: Array<any> = [];
  mail = "";
  loading = false;
  intentosContinuar = 0;
  havemails = true;

  constructor(
    private router: Router,
    private data: DataService,
    private getinfoServ: GetInformacionService,
    private dialogService: DialogService
  ) {}

  ngAfterViewInit(): void {
    this.data.isResume = false;
    this.getinfoServ
      .getInfoClient({ carpeta: this.data.numeroCarpeta.toString() })
      .subscribe(
        (resp) => {
          this.correos = resp.data.resultado.infoClient.listaCorreo || [];
          this.correos.push({ email: "Ninguna de los anteriores" });
        },
        (error) => console.error("Error al cargar correos:", error)
      );
  }

  /** Al pulsar "Continuar" */
  savemail(): void {
    if (this.mail === "Ninguna de los anteriores") {
      this.enviarValidacionOtp();
    } else {
      this.dialogService.openDialog(
        "Selecciona el medio de validación",
        "Elige el medio por el cual el cliente desea recibir la verificación para validación de identidad.pletar el proceso.",
        true,
        "Mensaje whatsapp",
        () => this.enviarValidacionWhatsApp(),
        true,
        "Código sms",
        () => this.enviarValidacionOtp()
      );
    }
  }

  enviarValidacionWhatsApp(): void {
    this.ejecutarEnvio("whatsapp");
  }

  enviarValidacionOtp(): void {
    this.ejecutarEnvio("otp");
  }

  private ejecutarEnvio(medio: "whatsapp" | "otp"): void {
    if (this.intentosContinuar > 0) {
      return;
    }
    this.loading = true;
    this.intentosContinuar = 1;
    this.data.isNewEmail = this.mail === "Ninguna de los anteriores";

    const value = this.data.isNewEmail ? 0 : 1;

    this.getinfoServ
      .saveCascadaMail({
        ind: value,
        correo: this.mail,
        carpeta: this.data.numeroCarpeta.toString(),
        cedula: this.data.cedula.toString(),
        medio,
      })
      .subscribe(
        (resp) => {
          console.log({ resp });
          this.router.navigateByUrl("/" + resp.data.ruta);
        },
        (err) => {
          this.loading = false;
          this.intentosContinuar = 0;
          console.log({ err });
          //this.modalAuto(err.error?.message || "Error inesperado");
        }
      );
  }

  /** Modal de error */
  // private modalAuto(mensaje: string): void {
  //   this.dialogService.openAlert("Error", mensaje);
  // }
}
